import { useRef } from 'react';
import { useDraggable } from 'react-use-draggable-scroll';
import { CarouselWrapper } from './Carousel.styles';

interface CarouselProps {
  children: React.ReactNode;
  className?: string;
}

const Carousel = ({ children, className }: CarouselProps) => {
  const carouselRef = useRef<HTMLElement>() as React.MutableRefObject<HTMLElement>;
  const { events } = useDraggable(carouselRef, { applyRubberBandEffect: true });

  return (
    <CarouselWrapper
      direction="row"
      spacing={2}
      {...events}
      ref={carouselRef}
      className={className}
    >
      {children}
    </CarouselWrapper>
  );
};

export default Carousel;
